__turbopack_context__.v({
  "subtitle": "typography-module__bC4IXG__subtitle",
  "title": "typography-module__bC4IXG__title",
});
